import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  border: "1",
  cellpadding: "1",
  cellspacing: "1"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["href"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["alt", "src"]
const _hoisted_21 = {
  border: "1",
  cellpadding: "1",
  cellspacing: "1"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = ["href"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 3 }


export default /*@__PURE__*/_defineComponent({
  __name: 'imageAndTable',
  props: {
    tableImageCollection: { default: () => [] },
    hasH1Hr: { type: Boolean, default: true },
    useTextH2: { type: Boolean, default: false },
    tableImage: { type: Boolean, default: false },
    wrap: { type: Boolean, default: false },
    titleCenter: { type: Boolean, default: false },
    center: { type: Boolean, default: false },
    hasul: { type: Boolean, default: false },
    span: { default: 6 },
    strong: { type: Boolean, default: false },
    h1Title: {},
    h2Title: {},
    pTitle: {},
    hasHr: { type: Boolean, default: true },
    hasLink: { type: Boolean, default: false },
    oneTd: { type: Boolean, default: false },
    h2TitleColor: { default: "#003399" }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.h1Title)
      ? (_openBlock(), _createElementBlock("h1", {
          key: 0,
          style: _normalizeStyle({ 'text-align': _ctx.titleCenter ? 'center' : 'left' })
        }, _toDisplayString(_ctx.h1Title), 5))
      : _createCommentVNode("", true),
    (_ctx.hasH1Hr)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.h2Title)
      ? (_openBlock(), _createElementBlock("h2", {
          key: 2,
          style: _normalizeStyle({ 'text-align': _ctx.titleCenter ? 'center' : 'left' })
        }, _toDisplayString(_ctx.h2Title), 5))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pTitle, (p, index) => {
      return (_openBlock(), _createElementBlock("p", {
        style: _normalizeStyle({ 'text-align': _ctx.titleCenter ? 'center' : 'left' }),
        key: index
      }, _toDisplayString(p), 5))
    }), 128)),
    _createVNode(_component_el_row, {
      class: "content",
      gutter: 30
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableImageCollection, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: _ctx.span,
            xl: _ctx.span,
            key: index
          }, {
            default: _withCtx(() => [
              (_ctx.tableImage)
                ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        (item.alt)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
                              (_ctx.hasLink)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: item.link
                                  }, [
                                    _createElementVNode("img", {
                                      src: item.imgUrl,
                                      alt: item.alt
                                    }, null, 8, _hoisted_5)
                                  ], 8, _hoisted_4))
                                : (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: item.imgUrl,
                                    alt: item.alt
                                  }, null, 8, _hoisted_6))
                            ]))
                          : (_openBlock(), _createElementBlock("td", _hoisted_7, [
                              (_ctx.hasLink)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: item.link
                                  }, [
                                    _createElementVNode("img", {
                                      src: item.imgUrl,
                                      alt: item.title
                                    }, null, 8, _hoisted_9)
                                  ], 8, _hoisted_8))
                                : (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: item.imgUrl,
                                    alt: item.title
                                  }, null, 8, _hoisted_10))
                            ]))
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          style: _normalizeStyle({ 'white-space': _ctx.wrap ? 'wrap' : 'nowrap', 'text-align': _ctx.center ? 'center' : 'left' })
                        }, [
                          (_ctx.strong)
                            ? (_openBlock(), _createElementBlock("strong", _hoisted_11, _toDisplayString(item.title), 1))
                            : (_ctx.useTextH2)
                              ? (_openBlock(), _createElementBlock("h2", _hoisted_12, [
                                  (_ctx.hasLink)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: item.link,
                                        style: _normalizeStyle({'color': _ctx.h2TitleColor})
                                      }, _toDisplayString(item.title), 13, _hoisted_13))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.title), 1))
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.title), 1)),
                          (_ctx.oneTd)
                            ? (_openBlock(), _createElementBlock("hr", _hoisted_16))
                            : _createCommentVNode("", true),
                          (item.textList && item.textList.length > 0 && _ctx.oneTd)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.textList, (imgTextItem, imgTextIndex) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    class: "text",
                                    key: imgTextIndex
                                  }, _toDisplayString(imgTextItem), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 4)
                      ]),
                      (_ctx.hasul)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                            _createElementVNode("td", {
                              style: _normalizeStyle({ 'white-space': _ctx.wrap ? 'wrap' : 'nowrap', 'text-align': _ctx.center ? 'center' : 'left' })
                            }, [
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.textList, (imgTextItem, imgTextIndex) => {
                                  return (_openBlock(), _createElementBlock("li", { key: imgTextIndex }, _toDisplayString(imgTextItem), 1))
                                }), 128))
                              ])
                            ], 4)
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (!_ctx.oneTd)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.textList, (imgTextItem, imgTextIndex) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: imgTextIndex }, [
                                    _createElementVNode("td", {
                                      style: _normalizeStyle({ 'white-space': _ctx.wrap ? 'wrap' : 'nowrap', 'text-align': _ctx.center ? 'center' : 'left' })
                                    }, _toDisplayString(imgTextItem), 5)
                                  ]))
                                }), 128))
                              : _createCommentVNode("", true)
                          ], 64))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("img", {
                      alt: item.alt,
                      src: item.imgUrl
                    }, null, 8, _hoisted_20),
                    _createElementVNode("table", _hoisted_21, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", {
                            style: _normalizeStyle({ 'white-space': _ctx.wrap ? 'wrap' : 'nowrap', 'text-align': _ctx.titleCenter ? 'center' : 'left' })
                          }, [
                            (_ctx.strong)
                              ? (_openBlock(), _createElementBlock("strong", _hoisted_22, _toDisplayString(item.title), 1))
                              : (_ctx.useTextH2)
                                ? (_openBlock(), _createElementBlock("h2", _hoisted_23, _toDisplayString(item.title), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    (_ctx.hasLink)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: item.link
                                        }, _toDisplayString(item.title), 9, _hoisted_25))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(item.title), 1))
                                  ]))
                          ], 4)
                        ]),
                        (_ctx.hasul)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                              _createElementVNode("td", {
                                style: _normalizeStyle({ 'white-space': _ctx.wrap ? 'wrap' : 'nowrap', 'text-align': _ctx.center ? 'center' : 'left' })
                              }, [
                                _createElementVNode("ul", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.textList, (imgTextItem, imgTextIndex) => {
                                    return (_openBlock(), _createElementBlock("li", { key: imgTextIndex }, _toDisplayString(imgTextItem), 1))
                                  }), 128))
                                ])
                              ], 4)
                            ]))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.textList, (imgTextItem, imgTextIndex) => {
                              return (_openBlock(), _createElementBlock("tr", { key: imgTextIndex }, [
                                (imgTextItem != undefined)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 0,
                                      style: _normalizeStyle({ 'white-space': _ctx.wrap ? 'wrap' : 'nowrap', 'text-align': _ctx.center ? 'center' : 'left' })
                                    }, [
                                      _createElementVNode("span", null, _toDisplayString(imgTextItem), 1)
                                    ], 4))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                      ])
                    ])
                  ]))
            ]),
            _: 2
          }, 1032, ["lg", "xl"]))
        }), 128))
      ]),
      _: 1
    }),
    (_ctx.hasHr)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_28))
      : _createCommentVNode("", true)
  ], 64))
}
}

})